import { render, staticRenderFns } from "./SearchBox.vue?vue&type=template&id=40a1b5d8"
import script from "./SearchBox.vue?vue&type=script&lang=js"
export * from "./SearchBox.vue?vue&type=script&lang=js"
import style0 from "./SearchBox.vue?vue&type=style&index=0&id=40a1b5d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports